import React from 'react'
import clsx from 'clsx'

import { CommonProps } from './types/common'

interface AvatarWrapperProps extends CommonProps {
  rootClassName: string
  ref: any
}

export const AvatarWrapper: React.FC<AvatarWrapperProps> = React.forwardRef(
  (props, ref: any) => {
    const {
      size,
      shape,
      showNotification,
      notificationStatus,
      notificationPosition,
      children,
      rootClassName,
    } = props

    const notificationBaseClassnames = [
      'absolute',
      'block',
      'rounded-full',
      'text-white',
      'shadow-solid',
    ]

    const sizeClassnames = {
      xs: {
        main: ['h-8', 'w-8'],
        notification: ['h-2', 'w-2'],
      },
      sm: {
        main: ['h-10', 'w-10'],
        notification: ['h-2.5', 'w-2.5'],
      },
      md: {
        main: ['h-12', 'w-12'],
        notification: ['h-3', 'w-3'],
      },
      lg: {
        main: ['h-14', 'w-14'],
        notification: ['h-3.5', 'w-3.5'],
      },
      xl: {
        main: ['h-16', 'w-16'],
        notification: ['h-4', 'w-4'],
      },
    }

    const notificationTransformClassnames = {
      'top-left': '-translate-y-1/2 -translate-x-1/2',
      'top-right': '-translate-y-1/2 translate-x-1/2',
      'bottom-left': 'translate-y-1/2 -translate-x-1/2',
      'bottom-right': 'translate-y-1/2 translate-x-1/2',
    }

    const notificationOffsetClassnames = {
      circle: '',
      box: ['transform', notificationTransformClassnames[notificationPosition]],
    }

    const notificationStatusClassnames = {
      default: 'bg-gray-300',
      active: 'bg-green-400',
      danger: 'bg-red-400',
    }

    const notificationPositionClassnames = {
      'top-left': 'top-0 left-0',
      'top-right': 'top-0 right-0',
      'bottom-left': 'bottom-0 left-0',
      'bottom-right': 'bottom-0 right-0',
    }

    return (
      <span ref={ref} className={rootClassName}>
        {children}
        {showNotification && (
          <span
            className={clsx(
              notificationBaseClassnames,
              sizeClassnames[size].notification,
              notificationOffsetClassnames[shape],
              notificationStatusClassnames[notificationStatus],
              notificationPositionClassnames[notificationPosition]
            )}
          />
        )}
      </span>
    )
  }
)
